import React, { Component, Fragment } from "react";
import app from "../../common/app";
import config from "../../common/config";
import core from "../../common/core";
// import { PullToRefresh, ReleaseContent, RefreshContent, PullDownContent } from "./../../plugin/react-js-pull-to-refresh";
// import Loader from './../loader';
import PullToRefresh from "pulltorefreshjs";
import { mixAPI } from "../../redux/apiUrls";
export default class PullToRefreshBasic extends Component {
  onRefresh = async () => {
    const { resetStore, objMix: objMixOld } = this.props;
    let now = new Date().getTime();
    let last = core.getLocalStorageValue(config.enumPullToRefresh.storage);
    if (now - last > config.enumPullToRefresh.threshold) {
      core.setLocalStorageValue(config.enumPullToRefresh.storage, now);
      resetStore();
      app.renderDom();
      /* const params = {
                url: mixAPI,
                loader: false,
                params: {
                    lang: config.CURRENT_LANGUAGE,
                },
            };

            const resp = await core.makeAPICall(params); 

            const objMix = resp && resp.data && resp.data.Data && resp.data.Data.Value;
            if (objMixOld && (objMixOld.JsVersion !== (objMix && objMix.JsVersion))) {
                window.location.reload();
            }
            else {
                core.setLocalStorageValue(config.enumPullToRefresh.storage, now);
                resetStore();
                app.renderDom();
            } */
    }
    /* return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
                let now = new Date().getTime();
                let last = core.getLocalStorageValue(config.enumPullToRefresh.storage);
                if ((now - last) > config.enumPullToRefresh.threshold) {
                    core.setLocalStorageValue(config.enumPullToRefresh.storage, now);
                    resetStore();
                    app.renderDom();
                }
            }, 2000);
        }); */
  };

  render() {
    return (
      <Fragment>{this.props.children}</Fragment>

      /* <PullToRefresh
               pullDownContent={<PullDownContent height={'100px'} />}
               releaseContent={<ReleaseContent style={{ height: '100px' }} />}
               refreshContent={<div style={{ height: '100px' }}><Loader /></div>}
               pullDownThreshold={100}
               onRefresh={this.onRefresh}
               triggerHeight={100}
           //startInvisible={true}
           //backgroundColor="white"
           > */
      /* </PullToRefresh> */
    );
  }
  setPullToRefresh = () => {
    const { onRefresh } = this;
    var _ptrStyles =
      "\n.__PREFIX__ptr {\n  box-shadow: inset 0 -3px 5px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n  font-size: 0.85em;\n  font-weight: bold;\n  top: 0;\n  height: 0;\n  transition: height 0.3s, min-height 0.3s;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  align-content: stretch;\n position: fixed;\n z-index: 99996;\n background-color: white;\n}\n\n.__PREFIX__box {\n  padding: 10px;\n  flex-basis: 100%;\n}\n\n.__PREFIX__pull {\n  transition: none;\n}\n\n.__PREFIX__text {\n  margin-top: .33em;\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.__PREFIX__icon {\n  color: rgba(0, 0, 0, 0.3);\n  transition: transform .3s;\n}\n\n/*\nWhen at the top of the page, disable vertical overscroll so passive touch\nlisteners can take over.\n*/\n.__PREFIX__top {\n  touch-action: pan-x pan-down pinch-zoom;\n}\n\n.__PREFIX__release .__PREFIX__icon {\n  transform: rotate(180deg);\n}\n";
    _ptrStyles = _ptrStyles
      .replace(/__PREFIX__/g, "ptr--")
      .replace(/\s+/g, " ");
    PullToRefresh.init({
      mainElement: "body",
      onRefresh: onRefresh,
      getStyles: function () {
        return _ptrStyles;
      },
      /* iconArrow: ReactDOMServer.renderToString(
                <FontAwesomeIcon icon={faSyncAlt} />
            ),
            iconRefreshing: ReactDOMServer.renderToString(
                <FontAwesomeIcon icon={faSyncAlt} spin={true} />
            ), */
    });
  };
  componentDidMount() {
    this.setPullToRefresh();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.isShowPullToRefresh !== nextProps.isShowPullToRefresh &&
      nextProps.isShowPullToRefresh > 0
    ) {
      this.setPullToRefresh();
    } else if (
      this.props.isShowPullToRefresh !== nextProps.isShowPullToRefresh &&
      nextProps.isShowPullToRefresh <= 0
    ) {
      PullToRefresh.destroyAll();
    }
  }

  componentWillUnmount() {
    // Don't forget to destroy all instances on unmout
    // or you will get some glitches.
    PullToRefresh.destroyAll();
  }
}
